import { render, staticRenderFns } from "./OrderPdfReport.vue?vue&type=template&id=a5d3243a&scoped=true&"
import script from "./OrderPdfReport.vue?vue&type=script&lang=js&"
export * from "./OrderPdfReport.vue?vue&type=script&lang=js&"
import style0 from "./OrderPdfReport.vue?vue&type=style&index=0&id=a5d3243a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d3243a",
  null
  
)

export default component.exports